// 店舗ページの別店舗リンクのクリック計測
const LINK_SELECTOR = '.js-click-nearby-shop'

// リンクは #detail= の差し替えで作り直されるため、要素ではなくdocumentに委譲して計測する
export const clickNearbyShop = (): void => {
  document.addEventListener('click', (event) => {
    const target = event.target
    if (!(target instanceof Element)) return
    if (target.closest(LINK_SELECTOR) === null) return

    window.gtag?.('event', 'click', { event_label: 'shop-nearby-shops' })
  })
}
